import { useApolloClient } from '@apollo/react-hooks';

const useShortIdsMapper = () => {
    const client = useApolloClient();
    return client.cache.shortIdsMapper;
};

export { useShortIdsMapper };
